import { signal } from "alien-signals";
import type { ChapterDetails } from "#/types";

export interface ChapterCache {
  bookId: number;
  chapterId: number;
  data: ChapterDetails;
}

export const currentChapterCacheSignal = signal<ChapterCache | null>(null);

export type ChapterUpdateListener = (cache: ChapterCache) => void;
const listeners: ChapterUpdateListener[] = [];

export function subscribeToChapterUpdate(listener: ChapterUpdateListener) {
  listeners.push(listener);
  return () => {
    const index = listeners.indexOf(listener);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  };
}

export function updateChapterCache(bookId: number, chapterId: number, data: ChapterDetails) {
  const cache = { bookId, chapterId, data };
  currentChapterCacheSignal(cache);
  listeners.forEach((l) => l(cache));
}

export function getCachedChapter(bookId: number, chapterId: number): ChapterDetails | null {
  const cache = currentChapterCacheSignal();
  if (cache && cache.bookId === bookId && cache.chapterId === chapterId) {
    return cache.data;
  }
  return null;
}
